import React from 'react';
import { Typography } from '@mui/material';
import FormattedText from './FormattedText';
import MessageDocumentCard from './MessageDocumentCard';
import MessageMediaFrame from './MessageMediaFrame';
import useMessageStyles from '../../../hooks/useMessageStyles';

export default function MessageHeaderBlock({ header, bleed = false }) {
  const { messageTemplateHeaderTextSx } = useMessageStyles();

  if (!header) return null;

  switch (header.kind) {
    case 'image':
      return header.url ? (
        <MessageMediaFrame
          kind="image"
          url={header.url}
          alt="Message header"
          bleed={bleed}
          compact
        />
      ) : null;

    case 'video':
      return header.url ? (
        <MessageMediaFrame kind="video" url={header.url} bleed={bleed} compact />
      ) : null;

    case 'document':
      return (
        <MessageDocumentCard
          fileName={header.fileName || 'Document'}
          fileUrl={header.url}
        />
      );

    case 'text':
    default:
      return header.text ? (
        <FormattedText text={header.text} variant="body2" sx={messageTemplateHeaderTextSx} />
      ) : null;
  }
}
